export const DOCTOR_RETRIEVE_REQUESTED = 'DOCTOR_RETRIEVE_REQUESTED';
export const DOCTOR_RETRIEVE_SUCCEED = 'DOCTOR_RETRIEVE_SUCCEED';
export const DOCTOR_RETRIEVE_FAILED = 'DOCTOR_RETRIEVE_FAILED';

export const DOCTOR_FEE_RETRIEVE_REQUESTED = 'DOCTOR_FEE_RETRIEVE_REQUESTED';
export const DOCTOR_FEE_RETRIEVE_SUCCEED = 'DOCTOR_FEE_RETRIEVE_SUCCEED';
export const DOCTOR_FEE_RETRIEVE_FAILED = 'DOCTOR_FEE_RETRIEVE_FAILED';

export const DOCTOR_CURRENCY_UPDATE_REQUESTED = 'DOCTOR_CURRENCY_UPDATE_REQUESTED';
export const DOCTOR_CURRENCY_UPDATE_SUCCEED = 'DOCTOR_CURRENCY_UPDATE_SUCCEED';
export const DOCTOR_CURRENCY_UPDATE_FAILED = 'DOCTOR_CURRENCY_UPDATE_FAILED';

export const DOCTOR_FEE_UPDATE_REQUESTED = 'DOCTOR_FEE_UPDATE_REQUESTED';
export const DOCTOR_FEE_UPDATE_SUCCEED = 'DOCTOR_FEE_UPDATE_SUCCEED';
export const DOCTOR_FEE_UPDATE_FAILED = 'DOCTOR_FEE_UPDATE_FAILED';

export const DOCTOR_CHAT_AVAILABLE_UPDATE_REQUESTED = 'DOCTOR_CHAT_AVAILABLE_UPDATE_REQUESTED';
export const DOCTOR_CHAT_AVAILABLE_UPDATE_SUCCEED = 'DOCTOR_CHAT_AVAILABLE_UPDATE_SUCCEED';
export const DOCTOR_CHAT_AVAILABLE_UPDATE_FAILED = 'DOCTOR_CHAT_AVAILABLE_UPDATE_FAILED';

export const WEBCHAT_DOCTOR_GET_CURRENCIES_REQUESTED = 'WEBCHAT_DOCTOR_GET_CURRENCIES_REQUESTED';
export const WEBCHAT_DOCTOR_GET_CURRENCIES_SUCCEED = 'WEBCHAT_DOCTOR_GET_CURRENCIES_SUCCEED';
export const WEBCHAT_DOCTOR_GET_CURRENCIES_FAILED = 'WEBCHAT_DOCTOR_GET_CURRENCIES_FAILED';

export const WEBCHAT_DOCTOR_SET_PRIORITY_FEE_REQUESTED =
  'WEBCHAT_DOCTOR_SET_PRIORITY_FEE_REQUESTED';
export const WEBCHAT_DOCTOR_SET_PRIORITY_FEE_SUCCEED = 'WEBCHAT_DOCTOR_SET_PRIORITY_FEE_SUCCEED';
export const WEBCHAT_DOCTOR_SET_PRIORITY_FEE_FAILED = 'WEBCHAT_DOCTOR_SET_PRIORITY_FEE_FAILED';

export const WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_REQUESTED =
  'WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_REQUESTED';
export const WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_SUCCEED =
  'WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_SUCCEED';
export const WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_FAILED =
  'WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_FAILED';

export const WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_REQUESTED =
  'WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_REQUESTED';
export const WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_SUCCEED =
  'WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_SUCCEED';
export const WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_FAILED =
  'WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_FAILED';

export const DOCTOR_GET_WORKING_TIMES_REQUESTED = 'DOCTOR_GET_WORKING_TIMES_REQUESTED';
export const DOCTOR_GET_WORKING_TIMES_SUCCEED = 'DOCTOR_GET_WORKING_TIMES_SUCCEED';
export const DOCTOR_GET_WORKING_TIMES_FAILED = 'DOCTOR_GET_WORKING_TIMES_FAILED';

export const DOCTOR_SET_WORKING_TIMES_REQUESTED = 'DOCTOR_SET_WORKING_TIMES_REQUESTED';
export const DOCTOR_SET_WORKING_TIMES_SUCCEED = 'DOCTOR_SET_WORKING_TIMES_SUCCEED';
export const DOCTOR_SET_WORKING_TIMES_FAILED = 'DOCTOR_SET_WORKING_TIMES_FAILED';
